import { EnvironmentProviders, Provider } from '@angular/core';
import {
  provideSoftAppsModule,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { getModuleGroupByName } from '@softline/application';
import { default as de } from '../i18n/de.json';
import { workflowRoutes } from './workflow.routes';
import { SOFTLINE_CONFIG_WORKFLOW_TYPE, WorkflowTypeConfig } from './workflow.shared';

export const provideWorkflowMonitorModule: () => Array<
  Provider | EnvironmentProviders
> = () => [
  provideSoftAppsModule(
    {
      name: 'workflows',
      title: 'Workflows',
      icon: 'fa-regular fa-arrow-progress',
      color: 'bg-warning text-black',
      route: '/workflow/overview',
      permission: 'SOFTAPPS.TASK_WORKFLOW',
      group: getModuleGroupByName('Gewerbe'),
    },
    withSoftAppsModuleRoutes({ app: workflowRoutes }),
    withSoftAppsModuleTranslation({
      de: de,
    })
  ),
  {
    provide: SOFTLINE_CONFIG_WORKFLOW_TYPE,
    useValue: {
      type: 'TASK',
      getRoute: (workflow) => ['/workflow/task', String(workflow.type.id)],
      getDetailComponent: () =>
        import('./pages/task-workflow/task-workflow').then((m) => m.TaskWorkflow),
      getDetailInputs: (workflow) => ({ taskIdInput: workflow.type.id, embedded: true }),
      viewModes: ['kanban', 'table'],
    } satisfies WorkflowTypeConfig,
    multi: true,
  },
];
